import initCustomScrollbar from "../modules/init-custom-scrollbar.js";

const initBlock = async function( block ) {
	initCustomScrollbar( block );

	if ( block.hasClass( "section-constructor-and-vendors--v2" ) ) {
		const $titles = block.find( ".requirement-card__title" );

		const alignTitlesHeight = function() {
			$titles.css( "min-height", "" );

			let maxHeight = 0;

			$titles.each( function() {
				const height = $( this ).outerHeight();
				if ( height > maxHeight ) {
					maxHeight = height;
				}
			} );

			if ( maxHeight > 0 ) {
				$titles.css( "min-height", maxHeight + "px" );
			}
		};

		alignTitlesHeight();

		$titles.find( "img" ).on( "load", function() {
			alignTitlesHeight();
		} );

		let resizeTimer;
		$( window ).on( "resize", function() {
			clearTimeout( resizeTimer );
			resizeTimer = setTimeout( function() {
				alignTitlesHeight();
			}, 100 );
		} );
	}
};

themeUtils.loadBlock( initBlock, "constructor-and-vendors", ".section-constructor-and-vendors" );
